import styled from "styled-components";
import Bg from "../../assets/bg-grid.svg";

export const MainContainer = styled.div`
  background-color: #72969b;
  background-image: url(${Bg});
  background-position: center;
  background-size: 100vw;

  display: flex;
  flex-direction: column;

  .questionPoints {
    position: relative;
    top: -1px;
  }
`;

export const ProgressDetails = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 25px;

  margin: 60px auto 40px;
  padding-right: 80px;
`;

export const WrongAnswersWrapper = styled.div`
  width: 70px;
  height: 26px;
  border-radius: 2px;
  background-color: #3e626a;

  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
`;

export const WrongAnswerIcon = styled.img`
  width: 12px;
  height: 12px;
`;

export const ProgressBarContainer = styled.div`
  background-color: #f3de8a;
  border-radius: 60px;
  width: 808px;
  height: 10px;

  display: flex;
  flex-direction: row;

  position: relative;
`;

export const TimerWrapper = styled.div`
  background-color: #3e626a;
  border-radius: 27px;
  width: 80px;
  height: 26px;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 17px;
`;

export const TimerIconWrapper = styled.div`
  background-color: #fe6030;
  height: 100%;
  width: 26px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TimerIcon = styled.img`
  height: 15px;
  width: 15px;

  margin-bottom: 1px;
`;

export const ProgressBarItem = styled.div`
  background-color: ${(props) => props.bgcolor};
  border-radius: 60px;

  flex: 1;

  &:first-of-type {
    border-top-left-radius: 60px;
    border-bottom-left-radius: 60px;
  }

  &:last-of-type {
    border-top-right-radius: 60px;
    border-bottom-right-radius: 60px;
  }

  ${({ $index, $activeIndex }) =>
    $index < $activeIndex - 1 &&
    `
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  `}

  ${({ $index, $activeIndex }) =>
    $index < $activeIndex &&
    `
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  `}

${({ $index, $activeIndex }) =>
    $index === $activeIndex + 1 &&
    `
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  `}
`;

export const SmallFlagBarContainer = styled.div`
  position: absolute;
  top: -25px;
  left: 370px;
`;

export const ProgressionSmallFlagBar = styled.div`
  border-radius: 50%;
  background-color: #fe6030;
  border: 8px solid;
  border-color: ${(props) => props.bordercolor};
  display: flex;
`;
export const ProgressionSmallFlagImage = styled.img`
  width: 25px;
  height: 25px;
  padding: 10px 7px 8px 10px;

  filter: ${({ filter }) =>
    filter
      ? "brightness(0) saturate(100%) invert(35%) sepia(20%) saturate(715%) hue-rotate(144deg) brightness(93%) contrast(88%)"
      : "none"};
`;

export const CorrectAnswersWrapper = styled.div`
  height: 26px;
  width: 80px;
  background-color: #3e626a;
  border-radius: 27px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CircleImage = styled.div`
  padding: 12px 19px;
  border-radius: 50%;
  background-color: #72969b;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const QuestionContainer = styled.div`
  margin: 40px 0 180px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const OrangeCircle = styled.div`
  background-color: #fe6030;
  border-radius: 50%;
  height: 30px;
  width: 30px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AnswersContainers = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 60px;

  margin-top: auto;
  padding: 0 100px 60px;
  background-color: #3e626a;
`;

export const AnswerItem = styled.div`
  width: 250px;
  height: 310px;

  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 70px;

  background-color: #fffbec;
  background-image: url(${({ bg }) => bg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  color: #72969b;
  border-radius: 10px;
  padding: 40px 20px;
  margin-top: -110px;
  text-align: center;

  cursor: pointer;
`;

export const CloseQuizContainer = styled.div`
  height: 80px;
  width: 90vw;
  position: absolute;
  top: 0;
  right: 5%;
  z-index: 2;
`;

export const CloseQuiz = styled.button`
  border: 0;
  position: absolute;
  background-color: var(--bg-dark-blue);
  height: 80px;
  width: 80px;
  top: 0;
  right: 0;
  border-radius: 0 0 10px 10px;

  &:hover {
    cursor: pointer;
  }
`;

export const CloseSVG = styled.img`
  height: 25px;
  width: 20px;
  padding: 30px 28px 26px 27px;
`;
